// Centralized breadcrumb helpers
// - LABEL_MAP: human-friendly labels per segment
// - buildBreadcrumbs: convert pathname to crumbs with cumulative hrefs

function normalizePathname(pathname) {
  if (!pathname) return "/";

  return pathname.replace(/\/+$/g, "");
}

export function stripAppPrefix(pathname) {
  return pathname.replace(/^\/app(\/|$)/, "/");
}

export function buildBreadcrumbs(pathname, overrides, dynamicParams, t) {
  const normalized = normalizePathname(pathname);
  const trimmed = normalized.replace(/^\/+|\/+$/g, "");

  if (!trimmed) return [{ label: t("HOME") || "Home" }];

  const segments = trimmed.split("/");
  const crumbs = [];
  let accumulator = "";
  for (let i = 0; i < segments.length; i++) {
    const segment = segments[i];
    accumulator += `/${segment}`;
    const isLast =
      i === segments.length - 1 || dynamicParams.includes(segment) || i === 1;
    const override = overrides && !!overrides[segment] ? overrides[segment] : undefined;
    const label =
      override ||
      t(segment.replaceAll("-", "_").toUpperCase()) ||
      decodeURIComponent(segment);
    crumbs.push({ label, href: isLast ? undefined : accumulator });
  }
  return crumbs;
}
